import { Component } from "vue-property-decorator";
import { LayerComponentBase } from "@/stellar-globe-components";
import { Layer, EquatorialCoord } from "@hscmap/stellar-globe";
import { dom } from "@/utils/dom";
import { V3 } from "@/utils/math";

@Component
export class PointerPicker extends LayerComponentBase<PointerPickerLayer> {
  newLayer() {
    return new PointerPickerLayer(this)
  }
}

class PointerPickerLayer extends Layer {
  constructor(readonly pp: PointerPicker) {
    super()
  }

  private off!: () => void
  onAdd() {
    this.off = dom.on(this.globe.canvas.domElement, 'mousemove', (e) => {
      const coord = this.globe.canvas.coordFromClientCoord(e)
      const xyz = this.globe.canvas.xyzFromClientCoord(e)
      this.pp.$emit('mousemove', new PointerPickerEvent(e, coord, xyz))
    })
  }

  onRemove() {
    this.off()
  }
}

export class PointerPickerEvent {
  constructor(
    readonly originalEvent: MouseEvent,
    readonly coord: EquatorialCoord,
    readonly xyz: V3,
  ) {
  }
}
